<style scoped>
.el-col-5{
  width: 30%;
}
  
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
         <el-col :span="8"
          ><div class="search-area-div">算法名称：</div>
          <el-select v-model="page.repositoryGuid" placeholder="请选择" class="w70f" filterable>
            <el-option
              v-for="item in repositoryNameList"
              :key="item.guid"
              :label="item.repositoryName"
              :value="item.guid">
            </el-option>
          </el-select>
          </el-col>
        <el-col :span="8"
          ><div class="search-area-div">参数名称：</div>
          <!-- <el-input v-model="page.parameter" class="ipt-sty w70f" placeholder="请输入类型"></el-input > -->
          <el-select v-model="page.parameterGuid" placeholder="请选择参数名称" class="w70f" filterable>
            <el-option
              v-for="item in sataDicList"
              :key="item.guid"
              :label="item.dataintroduction"
              :value="item.guid">
            </el-option>
          </el-select>
          </el-col> 
        <el-col :span="8">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">添加标准参数配置</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button>
      <!-- <el-button plain size="medium">历史数据</el-button> -->
    </div>
    <div class=" back-color-fff" style="padding: 16px;">
      <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%;">
        <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="parameter" label="参数名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="valueType" label="数据类型" header-align="center" align="center">
        <template slot-scope="scope">{{ scope.row.valueType | valueType }}</template>
        </el-table-column> 
        <el-table-column prop="parameterIllustration" label="参数说明" sortable header-align="center" align="center"></el-table-column>
        <el-table-column prop="state" label="状态" header-align="center" align="center">
        <template slot-scope="scope">{{ scope.row.state == 'Y'?'有效':'停用' }}</template>
        </el-table-column>
        <el-table-column prop="updateUserName" label="修改人" header-align="center" align="center"></el-table-column> 
        <el-table-column prop="updateTime" label="修改时间" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="add(2, scope.row)">编辑 | </a>
            <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        :label-position="right"
        class="demo-ruleForm"
      >
      <el-form-item label="算法名称:" prop="repositoryGuid"> 
          <el-select v-model="ruleForm.repositoryGuid" placeholder="请选择" class="w100f" filterable>
            <el-option
              v-for="item in repositoryNameList"
              :key="item.guid"
              :label="item.repositoryName"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="参数名称:" prop="parameterGuid">
        <!-- <el-input v-model="ruleForm.parameter" class="ipt-sty w100f" placeholder="数据值"></el-input> -->
          <el-select v-model="ruleForm.parameterGuid" placeholder="请选择参数名称" class="w100f" filterable>
            <el-option
              v-for="item in sataDicList"
              :key="item.guid"
              :label="item.dataintroduction"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item> 
        <el-form-item label="数据类型:" prop="valueType">
          <el-select v-model="ruleForm.valueType" placeholder="请选择" class="w100f" filterable>
            <el-option
              v-for="item in repositoryTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> 
        <el-form-item label="状态:" class="t-left">
          <el-radio v-model="ruleForm.state" label="Y">有效</el-radio>
          <el-radio v-model="ruleForm.state" label="S">停用</el-radio>
        </el-form-item>
        <el-form-item label="参数说明:" prop="parameterIllustration">
          <el-input type="textarea" v-model="ruleForm.parameterIllustration"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" v-if="textTitle == '预置参数添加'" @click="submitForm('ruleForm')"
          >确定</el-button
        >
        <el-button size="medium" type="info" v-else @click="upDateForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: '',
      textTitle: '',
      right: '',
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      ruleForm: {
        guid: '',
        parameterCode: '',
        parameterGuid:'',
        parameter: '', 
        repositoryGuid: '',
        repositoryName:'',
        valueType:'',
        parameterIllustration:'',
        state:'Y',
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0, 
        parameterGuid:'',
        parameter: '', 
        repositoryGuid:''
      },
      dto:{
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0,
      },
      tableData: [],
      rules: { 
          parameterGuid: [
            { required: true, message: '请选择参数名称', trigger: 'change' }
          ],
          repositoryGuid: [
            { required: true, message: '请选择算法名称', trigger: 'change' }
          ],
          valueType: [
            { required: true, message: '请选择数据类型', trigger: 'change' }
          ],
          parameterIllustration: [
            { required: true, message: '请输入参数说明', trigger: 'blur' },
            { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
          ],
      },
      multipleSelection: [],
      repositoryNameList:[],
      sataDicList:[],
      repositoryTypeList:[{
          label:'数字(tinyint)',
          value:'1'
      },{
          label:'数字(int）',
          value:'2'
      },{
          label:'使用option下拉框(单选)',
          value:'3'
      },{
          label:'使用option下拉框(多选)',
          value:'4'
      },{
          label:'使用radio选项卡',
          value:'5'
      },{
          label:'时间区间',
          value:'6'
      },{
          label:'checkbox多选框',
          value:'7'
      },{
          label:'文本框',
          value:'8'
      }],
    };
  },
  created() {
    // 列表
    this.getData(false);
    this.getrepositoryTypeList();
    this.getDataDic();
  },
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        parameter: '', 
        repositoryGuid:''
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      // self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/sys-conf/import-param/get`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          // self.tableData.forEach(function(item) {
          //   item.bizState = item.bizState == 'Y' ? '有效' : '停用';
          // });
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getDataDic() {
      let self = this;  
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/sys-conf/data-dic/get`,{'pageIndex':1,'pageSize':'-1'}).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.sataDicList = res.data.data.records;  
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getrepositoryTypeList() {
      let self = this; 
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/math-repository/data/get`, self.dto).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.repositoryNameList = res.data.data.records; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },

    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msAiAlgorithmService}/sys-conf/import-param/delete`, self.multipleSelection)
            .then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success('删除标准参数配置成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    add(flg, row) {
      let self = this;
      if (flg == 1) {
        self.textTitle = '预置参数添加';
        self.ruleForm.parameter = '';
        self.ruleForm.repositoryGuid = '';
        self.ruleForm.repositoryName = '',
        self.ruleForm.valueType = '';
        self.ruleForm.parameterIllustration = '',
        self.ruleForm.state = 'Y';
      } else {
        self.textTitle = '预置参数编辑';
        self.ruleForm.guid = row.guid; 
        self.ruleForm.parameter = row.parameter; 
        self.ruleForm.repositoryGuid = row.repositoryGuid;
        self.ruleForm.valueType = row.valueType;
        self.ruleForm.parameterIllustration = row.parameterIllustration;
        self.ruleForm.state = row.state;
      }
      this.dialogFormVisible = true;
    },
    submitForm(formName) {
      let self = this;
      if(self.ruleForm.repositoryGuid != null && self.ruleForm.repositoryGuid != ''){
            self.repositoryNameList.forEach(function(i){
                  if(i.guid == self.ruleForm.repositoryGuid){
                        self.ruleForm.repositoryName = i.repositoryName
                  }
            })
      }
      if(self.ruleForm.parameterGuid != null && self.ruleForm.parameterGuid != ''){
            self.sataDicList.forEach(function(i){
                  if(i.guid == self.ruleForm.parameterGuid){
                        self.ruleForm.parameter = i.dataintroduction;
                        self.ruleForm.parameterCode = i.datavalue;
                  }
            })
      }
      self.$refs[formName].validate(valid => {
        if (valid) {
          let promise = { 
            parameter: self.ruleForm.parameter,
            repositoryGuid:self.ruleForm.repositoryGuid,
            repositoryName:self.ruleForm.repositoryName, 
            valueType: self.ruleForm.valueType,
            parameterIllustration: self.ruleForm.parameterIllustration,
            state: self.ruleForm.state,
            parameterCode:self.ruleForm.parameterCode
          };
          self.api.postJson(`/${serverConfig.msAiAlgorithmService}/sys-conf/import-param/add`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('添加标准参数配置成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    upDateForm(formName) {
      let self = this;
      if(self.ruleForm.repositoryGuid != null && self.ruleForm.repositoryGuid != ''){
            self.repositoryNameList.forEach(function(i){
                  if(i.guid == self.ruleForm.repositoryGuid){
                        self.ruleForm.repositoryName = i.repositoryName
                  }
            })
      }
       if(self.ruleForm.parameterGuid != null && self.ruleForm.parameterGuid != ''){
            self.sataDicList.forEach(function(i){
                  if(i.guid == self.ruleForm.parameterGuid){
                        self.ruleForm.parameter = i.dataintroduction;
                        self.ruleForm.parameterCode = i.datavalue;
                  }
            })
      }
      self.$refs[formName].validate(valid => {
        if (valid) {
          let promise = {
            guid: self.ruleForm.guid,
            parameter: self.ruleForm.parameter,
            repositoryName:self.ruleForm.repositoryName,
            repositoryGuid: self.ruleForm.repositoryGuid,
            valueType: self.ruleForm.valueType,
            parameterIllustration: self.ruleForm.parameterIllustration,
            state: self.ruleForm.state,
            parameterCode:self.ruleForm.parameterCode
          };
          self.api.put(`/${serverConfig.msAiAlgorithmService}/sys-conf/import-param/update`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('编辑标准参数配置成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
